export default __webpack_public_path__ + "static/media/lynn-close.28b4a6c0.jpg";